<div class="container pb-1">
  <p class="mt-4">
    All information provided on this site is intended solely for the study purposes related to
    trading on financial markets. Bright Transact LLP. It does not serve in any way as a specific
    investment recommendation, business recommendation, investment opportunity analysis, or similar
    general recommendation regarding the trading of investment instruments.
  </p>
  <p>2025 &copy; Copyright - Bright Funded.com Made with ❤️ for trading.</p>
</div>
